import {
  KeyboardArrowDown,
  Delete,
  Edit
} from "@material-ui/icons";
import React from "react";
import { Button, Col,Form, Modal, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import {
  getUserRolesAction,
  addUserRolesAction,
  deleteRolesAction,
  editRolesAction,
  getRolesAction
} from "./../../actions/UserActions";
import noRecord from "./../../assets/img/no-record.png";
import DeletePrompt from '../Common/DeletePrompt';

class Roles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: props.title || "Roles",
      showLoader: true,
      data: [],
      deletePrompt: false,
      userId: "",
      showAddModal: false,
      addName: "",
      showEditPrompt: false,
      editId: ""
    };
    this.removeDatabyId = this.removeDatabyId.bind(this);
  }

  columns = [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      ignoreRowClick: true
    },
    {
      name: "",
      selector: "action",
      right: true,
      ignoreRowClick: true,
      width: "150px"
    }
  ];

  getRole() {
    this.props.getRolesAction().then(res => {
      this.setState({
        data: res || [],
        showLoader: false
      });
    }).catch(err => {})
  }
  componentWillMount() {
    this.getRole();
  }

  removeDatabyId(uId) {
    this.setState({ showLoader: true, deletePrompt: false });
    this.props.deleteRolesAction(uId).then(res => {
      this.setState({ showLoader: false });
      this.getRole();
    });
  }

  openDeletePrompt(id) {
    this.setState({
      deletePrompt: true,
      userId: id
    });
  }

  openEditPrompt(user) {
    this.setState({
      showEditPrompt: true,
      editId: user._id,
      addName: user.type
    });
  }

  openAddModal() {
    this.setState({
      showAddModal: true
    });
  }

  addRole(name) {
    this.props.addUserRolesAction({ type: name }).then(res => {
      this.setState({
        showAddModal: false,
        addName: ""
      });
      this.getRole();
    });
  }

  editRole(name, id) {
    this.props.editRolesAction({ type: name }, id).then(res => {
      this.setState({
        showEditPrompt: false,
        addName: ""
      });
      this.getLeadSource();
    });
  }

  render() {
    let rows = [];

    for (var i = 0, len = this.state.data.length; i < len; i++) {
      let user = this.state.data[i];

      let data = {
        name: user.name,
        // action: (
        //   <div className="action-btns">
        //     <Button
        //       variant="transparent"
        //       onClick={() => {
        //         this.openEditPrompt(user);
        //       }}
        //     >
        //       <Edit />
        //     </Button>
        //     <Button
        //       variant="transparent"
        //       onClick={() => {
        //         this.openDeletePrompt(user._id);
        //       }}
        //     >
        //       <Delete />
        //     </Button>
        //   </div>
        // )
      };

      rows.push(data);
    }

    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col className="col-auto">
            <h4 className="title-med mt-0 pt-1">{this.state.title}</h4>
          </Col>
          <Col className="col-auto">
            <Form.Group controlId="" className="mb-0 mr-2"></Form.Group>
          </Col>
          {/* <Col align="right">
            <Button
              onClick={() => {
                this.openAddModal();
              }}
              className="btn btn-primary btn-blue btn-head w-140"
            >
              Add
            </Button>
          </Col> */}
        </Row>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <DataTable
              columns={this.columns}
              data={rows}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Data Found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
              onRowSelected={this.getSelectedRows}
            />

            {this.state.showLoader === true && (
              <div className="page-loader">
                <div className="page-loader-inner">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            )}
            
            <DeletePrompt 
              deletePrompt = {this.state.deletePrompt}
              itemId = {this.state.userId}
              cancel = {() => { this.setState({ deletePrompt: false }) }}
              deleteConfirm = {this.removeDatabyId}
            />

            <Modal
              show={this.state.showAddModal}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med modal-400"
              backdrop={false}
            >
              <Modal.Header>
                <Modal.Title id="example-custom-modal-styling-title">
                  Add Role
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="pb-0">
                <div className="form-group">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    name="name"
                    onChange={e => {
                      this.setState({ addName: e.target.value });
                    }}
                  ></Form.Control>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="btn-blue w-140"
                  onClick={() => {
                    this.addRole(this.state.addName);
                  }}
                  disabled={this.state.addName.trim() == ""}
                >
                  Add
                </Button>
                <Button
                  variant="primary"
                  className="btn-blue btn-outlined w-140"
                  onClick={() => {
                    this.setState({ showAddModal: false });
                  }}
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>

            {/* Edit Data Modal */}
            <Modal
              show={this.state.showEditPrompt}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med modal-400"
              backdrop={false}
            >
              <Modal.Header>
                <Modal.Title id="example-custom-modal-styling-title">
                  Edit Role
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="pb-0">
                <div className="form-group">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    name="name"
                    value={this.state.addName}
                    onChange={e => {
                      this.setState({ addName: e.target.value });
                    }}
                  ></Form.Control>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="btn-blue w-140"
                  onClick={() => {
                    this.editRole(this.state.addName, this.state.editId);
                  }}
                >
                  Add
                </Button>
                <Button
                  variant="primary"
                  className="btn-blue btn-outlined w-140"
                  onClick={() => {
                    this.setState({ showEditPrompt: false });
                  }}
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    roles: state.reducer.roles
  };
};

export default connect(mapStateToProps, {
  getUserRolesAction,
  addUserRolesAction,
  deleteRolesAction,
  editRolesAction,
  getRolesAction
})(Roles);